import {
    types
} from './types';

import firebase from '../firebase/firebase';

const db = firebase.database();

export const getKPIInfo = (uid) => async dispatch => {
    console.log('GETTING KPI INFO...', uid)
    const kpiTriggerRef = db.ref(`kpiTrigger/${uid}`);
    kpiTriggerRef.set('awaitingResponse', (error) => {
        if (!error) {
            console.log('AWAITING KPI DATA...');
            kpiTriggerRef.off();

            kpiTriggerRef.set(null, (error) => {
                if (!error) {
                    kpiTriggerRef.on('value', snap => {
                        console.log('GOT A RESPONSE');
                        if (snap.val() && snap.val() !== 'awaitingResponse') {
                            console.log('KPI DATA:', snap.val());
                            dispatch({
                                type: types.GET_KPI_DATA_SUCCESS,
                                payload: snap.val()
                            })
                            kpiTriggerRef.off();
                        }
                    }, e => console.log)
                }
            })
        } else {
            console.log('Could not get KPI info.')
        }
    })
}


// WEBPACK FOOTER //
// ./src/js/actions/kpi-actions.js